import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { ElementRef, Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { defaultThemeVariables } from '../themes/default-theme-variables';
import {
  Theme,
  ThemeAlt,
  ThemeDefault,
  ThemeCare,
  ThemeMyvm,
  ThemeSales,
  ThemeNames,
  ThemeSalesVmo2,
  ThemeSalesSimBoltOn,
  ThemeVmo2,
  ThemeSalesNonVolt,
} from './themes';
@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private mainTheme$: BehaviorSubject<Theme> = new BehaviorSubject(ThemeDefault);
  private readonly startTheme: Theme;
  private themeAlt: Theme = ThemeAlt;
  private themeVars = Object.keys(defaultThemeVariables);
  private themeSalesVmo2: Theme = ThemeSalesVmo2;
  private themeCare: Theme = ThemeCare;
  private themeMyvm: Theme = ThemeMyvm;
  private themeSales: Theme = ThemeSales;
  private themeDefault: Theme = ThemeDefault;
  private themeSalesSimBoltOn: Theme = ThemeSalesSimBoltOn;
  private themeVmo2: Theme = ThemeVmo2;
  private themeSalesNonVolt: Theme = ThemeSalesNonVolt;
  public currentTheme: Theme = this.themeDefault;
  private themeNames = ThemeNames;

  constructor(@Inject(DOCUMENT) document: Document, @Inject(PLATFORM_ID) private platformId: object) {
    if (isPlatformBrowser(this.platformId)) {
      this.mainTheme$.subscribe(this.onThemeChange.bind(this));
      // @ts-ignore
      this.startTheme = { name: null, properties: {} };
      this.themeVars.forEach((cssVar) => {
        this.startTheme.properties[cssVar] = getComputedStyle(document.documentElement).getPropertyValue(cssVar);
      });
    }
  }

  async onThemeChange(mainTheme: Theme) {
    this.currentTheme = mainTheme;
    Object.keys(this.currentTheme.properties).forEach((property) => {
      document.documentElement.style.setProperty(property, this.currentTheme.properties[property]);
    });
  }

  setMainTheme(name: Theme) {
    if (name === this.themeDefault) {
      name = this.startTheme;
    }
    this.mainTheme$.next(name);
  }

  applyTheme(themeName: string) {
    const theme = this.getThemeByName(themeName);
    this.setMainTheme(theme);
  }

  resetTheme() {
    this.setMainTheme(this.themeDefault);
  }

  applyThemeForElm(elm: ElementRef, themeName: string) {
    const theme = this.getThemeByName(themeName);
    Object.keys(theme.properties).forEach((property) => {
      elm.nativeElement.style.setProperty(property, theme.properties[property]);
    });
  }

  private getThemeByName(themeName: string): Theme {
    let theme: Theme;

    switch (themeName) {
      case this.themeNames.CARE:
        theme = this.themeCare;
        break;
      case this.themeNames.MYVM:
        theme = this.themeMyvm;
        break;
      case this.themeNames.SALES:
        theme = this.themeSales;
        break;
      case this.themeNames.SALES_VMO2:
        theme = this.themeSalesVmo2;
        break;
      case this.themeNames.ALT:
        theme = this.themeAlt;
        break;
      case this.themeNames.SALES_SIM_BOLT_ON:
        theme = this.themeSalesSimBoltOn;
        break;
      case this.themeNames.VMO2:
        theme = this.themeVmo2;
        break;
      case this.themeNames.SALES_NON_VOLT:
        theme = this.themeSalesNonVolt;
        break;
      default:
        theme = this.themeDefault;
        break;
    }
    return theme;
  }
}
